import { FormErrors } from "redux-form";

import { ATT_MATRIX_VALS } from "../Wizard/constants";
import {
  ProjectInfoFormValues,
  AugmentedProjectInfoFormProps,
} from "./components/ProjectInfoForm";

// Select options not checked for changes; not important on client, leave to server
function validate(
  formValues: ProjectInfoFormValues,
  props: AugmentedProjectInfoFormProps,
) {
  const errors: FormErrors<ProjectInfoFormValues> = {};
  const { attribute: attMatrix } = props.chosenProduct;

  const genRequiredMsg = () => "Cần thiết";
  const genGuardMsg = (num = 0) => `Phải lớn hơn ${num}`;

  // Check dimension fields if required (at least 1 needs to be in...)
  if (attMatrix.dimension === ATT_MATRIX_VALS.REQ) {
    if (!formValues.dimension_width) {
      errors.dimension_width = genRequiredMsg();
    } else if (!formValues.dimension_height) {
      errors.dimension_height = genRequiredMsg();
    } else if (!formValues.dimension_depth) {
      errors.dimension_depth = genRequiredMsg();
    }
  }

  // Guard dimension fields, if set
  if (
    formValues.dimension_width &&
    +formValues.dimension_width &&
    +formValues.dimension_width < 0
  ) {
    errors.dimension_width = genGuardMsg();
  }
  if (
    formValues.dimension_height &&
    +formValues.dimension_height &&
    +formValues.dimension_height < 0
  ) {
    errors.dimension_height = genGuardMsg();
  }
  if (
    formValues.dimension_depth &&
    +formValues.dimension_depth &&
    +formValues.dimension_depth < 0
  ) {
    errors.dimension_depth = genGuardMsg();
  }

  // Material field stored as array of files
  if (!formValues.material || !formValues.material.length) {
    errors.material = { _error: genRequiredMsg() } as any;
  } else {
    const materialErrors: Array<string> = [];
    formValues.material.forEach((val, i) => {
      if (!val.name || !val.name.length || !val.url || !val.url.length) {
        materialErrors[i] = genRequiredMsg();
      }
    });
    errors.material = materialErrors as any;
  }

  // Rest treated the same; just check for required... for now
  for (const key of [
    "title",
    "content",
    "audience",
    "industry",
    "page_number",
    "primary_color",
    "secondary_color",
  ]) {
    if (attMatrix[key] === ATT_MATRIX_VALS.REQ && !formValues[key]) {
      errors[key] = genRequiredMsg();
    }
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/routes/Step4/project-form-validation.ts